export const SIDE_BAR = 'wiki-how/howtosidebar';
export const GLOSSARY_SIDE_BAR = 'glossary/sidebar';
